import {Component, ElementRef, Inject, Renderer2} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {MockupDataModel} from '../../../qr-copy-message/mockup-data.model';
import {SnackBarUtil} from '../../../qr-copy-message/snack-bar-util.service';

@Component({
  selector: 'app-menu-show-qr-modal',
  templateUrl: './menu-show-qr-modal.component.html',
  styleUrl: './menu-show-qr-modal.component.scss'
})
export class MenuShowQrModalComponent {
  qrCodeUrl: SafeUrl = '';

  constructor(
    public dialogRef: MatDialogRef<MenuShowQrModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      menuName: string;
      address: string;
      qrCodeBase64: string;
      menuUrl: string;
      menuId: number;
    },
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private snackBarUtil: SnackBarUtil,
    private translate: TranslateService,
    private router: Router
  ) {
    if (data.qrCodeBase64) {
      this.qrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${data.qrCodeBase64}`);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  copyLink() {
    if (this.data.menuUrl) {
      navigator.clipboard.writeText(this.data.menuUrl).then(() => {
        this.translate.get('copy_success.url_copy_success_alert').subscribe((res: string) => {
          this.showSnackbar(MockupDataModel.success(res), SnackBarUtil.CLASSES.success);
        });
      });
    }
  }

  shareLink() {
    if (navigator.share) {
      navigator.share({
        title: this.data.menuName,
        text: `Check out ${this.data.menuName} menu`,
        url: this.data.menuUrl
      }).catch(() => {});
    }
  }

  saveImage() {
    const imageSrc = this.qrCodeUrl.toString();
    const link = this.renderer.createElement('a');
    this.renderer.setAttribute(link, 'href', imageSrc);
    this.renderer.setAttribute(link, 'download', 'qr_code.png');
    this.renderer.setStyle(link, 'display', 'none');
    this.renderer.appendChild(this.elRef.nativeElement.ownerDocument.body, link);
    link.click();
    this.renderer.removeChild(this.elRef.nativeElement.ownerDocument.body, link);
  }

  openMenu() {
    if (!this.data.menuId) {
      return;
    }
    this.dialogRef.close();
    this.router.navigate([`/menu/view/${this.data.menuId}`]).catch();
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 1000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }
}
